import cqrsApiService from "@/app/shared/services/cqrsApiService.js";

export default {
  add(task, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Tasks/Create", { task }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  edit(task, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Tasks/Edit", { task }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  delete(id, vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/Tasks/Delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}